export const WHATSAPP_NUMBER = "5511927327321";
export const WHATSAPP_DISPLAY = "(11) 92732-7321";
export const INSTAGRAM_HANDLE = "@nexusdesing.digital";
export const INSTAGRAM_URL = "https://www.instagram.com/nexusdesing.digital/";
export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
